import type { ToolContent } from "@/types/tools";
import { CDN_URL } from "@/consts";
import Image from "next/image";

interface MP3ConverterProps {
  content: ToolContent;
}

const MP3Converter = ({ content }: MP3ConverterProps) => {
  return (
    <Image
      src={`${CDN_URL}/features/free/mp3-converter/hero-component.png`}
      alt="MP3 Converter"
      width={660}
      height={260}
      draggable={false}
      className="h-auto max-w-[268px] select-none md:max-w-[330px]"
    />
  );
};

export default MP3Converter;
